import React from 'react';
import classNames from 'classnames';

import {
  Banner,
  Breadcrumbs,
  CallBlock,
  InternetBanner,
  TextBlock,
} from '@/ui/index';

import Questions from '../Questions/Questions';

import styles from './Advantageous.module.scss';

const Advantageous = ({ data }) => {
  return (
    <div itemScope itemType='https://schema.org/Offer'>
      {data?.breadcrumbs && <Breadcrumbs data={data.breadcrumbs} />}
      {data?.mainBanner && (
        <InternetBanner bannerData={data.mainBanner} medium />
      )}
      <div className={'wrapper little-margin'}>
        {data?.campaignTable?.mainText && (
          <TextBlock className={classNames([styles.text, 'text--large'])}>
            {data.campaignTable.mainText}
          </TextBlock>
        )}
        <CallBlock />
      </div>
      {data?.questions2 && (
        <Questions
          title={null}
          className={classNames([styles.faq, 'wrapper'])}
          questions={data.questions2}
        />
      )}
      {data?.banner2 && <Banner item={data.banner2} />}
    </div>
  );
};

export default Advantageous;
